import React from 'react'
import AuthLayout from '../../custom/components/templates/AuthLayout'
import '../Login/Login.css'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'

import { LOGO, SITE_NAME } from '@/utils'
import ForgetComponent from './forgetComponent'
//forgetpassword page
const ForgotPassword = () => {
    const validationArray = Yup.object({
        email: Yup.string().email('invalid email format').required('Required'),
    })

    const initialValues = {
        email: '',
    }
    const forgotValues = [
        {
            label: 'Email address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12',
            autoFocus: true,
        },
    ]

    return (
        <AuthLayout>
            <div className="auth-top">
                <h2 className="auth-head-title">Reset Password</h2>
                <p className="auth-note">
                    Enter your email address to receive a link to reset your password.
                </p>
            </div>
            <ForgetComponent
                validationArray={validationArray}
                initialValues={initialValues}
                forgotValues={forgotValues}
                onSuccess={false}
            />
        </AuthLayout>
    )
}
export default ForgotPassword
